"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PollPinSchema = exports.MapPinSchema = exports.LinkPinSchema = exports.DragQuestionPinSchema = void 0;
const zod_1 = require("zod");
const base_pin_1 = require("./base-pin");
// TODO: Move to own files and replace with actual implementation when we support them
// This was created to make the port easier
exports.DragQuestionPinSchema = base_pin_1.BasePinSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('DRAG_QUESTION'),
}));
exports.LinkPinSchema = base_pin_1.BasePinSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('LINK'),
}));
exports.MapPinSchema = base_pin_1.BasePinSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('MAP'),
}));
exports.PollPinSchema = base_pin_1.BasePinSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('POLL'),
}));
//# sourceMappingURL=placeholder-pins.js.map